import { ILoyaltyProgramDTO, ILoyaltyProgramViewDTO } from "../../libs/coreapi-dto/dirs/loyaltyProgram";
import CoreApiService from "../../system/api/coreApiService";
import { DictionaryDataProvider } from "./Common";

export class LoyaltyProgramDataProvider extends DictionaryDataProvider<ILoyaltyProgramDTO, ILoyaltyProgramViewDTO> {

    private _coreApiService: CoreApiService

    constructor(coreApiService: CoreApiService) {
        super();
        this._coreApiService = coreApiService
    }

    getDataRequest(): Promise<IDictionaryRequest<ILoyaltyProgramDTO, ILoyaltyProgramViewDTO>> {
        return this._coreApiService.loyaltyProgramRequest
    }
}